// extracted by mini-css-extract-plugin
export default {"container":"lK-z","topReviewHeading":"mK-z","criticalReview":"nK-z","favorableReview":"oK-z","vsSeparator":"pK-z"};